import * as React from 'react'
import { Modal } from 'reactstrap'

import './styles.scss'
import { BrandsAndDelegations, Button } from 'components/Form'
import { I18n } from 'react-redux-i18n'
import { companyResources } from 'api'
import UploadFiles from 'components/UploadFiles'
import { MAX_FILE_SIZE } from 'constants/filesMaxSize'
import { getStaticImage } from 'utils/statics'

const ResourcesDetail = (props) => {
  const { toggle, save, valuesToEdit, isSubmitting } = props
  const [brands, setBrands] = React.useState([])
  const [delegations, setDelegations] = React.useState([])
  const [resource, setResource] = React.useState({})
  const [messageError, setMessageError] = React.useState(null)
  const [disabled, setDisabled] = React.useState(true)

  React.useEffect(()=> {
    if (valuesToEdit._id) {
      companyResources.getById(valuesToEdit._id).then(result => {
        setResource(result.data)
        setBrands(result.data.brands)
        setDelegations(result.data.delegations)
      }).catch(error => {
        console.error(error)
      })
    }
  }, [valuesToEdit])

  React.useEffect(()=>{
    setMessageError(null)
  }, [brands, delegations, resource])

  const onChangeRefBrandsDelegations = (values) => {
    if (values) {
      let allowEditName = false
      if (values.brands && values.brands.length > 0) {
        values.brands.forEach(it => {
          if (it.isFixed) {
            allowEditName = true
          }
        })
      }
      if (values.delegations && values.delegations.length > 0) {
        values.delegations.forEach(it => {
          if (it.isFixed) {
            allowEditName = true
          }
        })
      }
      setDisabled(allowEditName)
    }
  }

  const onClick = () => {
    if (brands.length < 1) {
      setMessageError(I18n.t('dashboard_errors_you-must-select-brand'))
      return
    }
    if (delegations < 1) {
      setMessageError(I18n.t('dashboard_errors_you-must-select-delegation'))
      return
    }
    if (!resource || !resource.name || resource.name.length < 0) {
      setMessageError(I18n.t('resources_error_required_name'))
      return
    }
    resource['brands'] = brands
    resource['delegations'] = delegations
    save(resource)
  }

  const onDrop = (_files) => {
    if (_files.length > 0)
      setResource({ ...resource, name: _files[0].name, files: _files[0].file, })
  }

  return (
    <div className='categories-detail'>
      <Modal centered isOpen={props.isOpen} toggle={props.toggle} className={''} contentClassName={'modal-content-categories'}>
        <div className='modal-wrapper-header'>
          <h1>{resource._id ? I18n.t('dashboard_edit-resource') : I18n.t('dashboard_add-resource')}</h1>
          <span onClick={props.toggle}>
            <img src={getStaticImage('/icons/orange-brand/icon-close.svg')} alt='Close'/>
          </span>
        </div>
        <legend dangerouslySetInnerHTML={{ __html:resource._id ? I18n.t('resources_edit_resource_legend') : I18n.t('resources_add_resource_legend') }}/>

        <BrandsAndDelegations
          onChangeBrands={(value)=>setBrands(value, 'brand')}
          currentBrands={brands || []}
          onChangeDelegations={(value)=>setDelegations(value, 'delegation')}
          currentDelegations={delegations || []}
          grouped={false}
          setRefBrandsDelegations={onChangeRefBrandsDelegations}
        />

        {!resource._id &&
          <>
            <label htmlFor='file'>Archivo</label>
            <UploadFiles
              multiple={false}
              onRemoveUploadedFile={() => setResource({ ...resource, files: [], name: '' })}
              removeOnDrop={true}
              maxSize={MAX_FILE_SIZE}
              messageErrorSize={I18n.t('file-too-big')}
              onDrop={onDrop}
              removeButtons={true}
            />
          </>
        }

        <label htmlFor='name'>{I18n.t('dashboard_name')}</label>
        <input
          id={'input-modal'}
          name='name'
          type='text'
          defaultValue={resource.name}
          onChange={(value) => setResource({ ...resource, name: value.target.value })} disabled={disabled}
        />
        <small className='error'>{messageError}</small>

        <div className='wrapper-buttons'>
          <Button
            secondary={true}
            value={I18n.t('dashboard_save')}
            onClick={onClick}
            isSubmitting={isSubmitting}
          />
          <Button
            value={I18n.t('dashboard_cancel')}
            onClick={toggle}
          />
        </div>

      </Modal>
    </div>
  )
}

export default ResourcesDetail